module.exports = __webpack_public_path__ + "static/img/logo-vertical-minjus-2021.48476cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vertical-minjus-2021.jpg
// module id = qX30
// module chunks = 9